import { createContext, useContext } from "react";

/* Hilux */
import onix12 from "../assets/molelos/onix.webp";
import s10 from "../assets/molelos/s10.webp";
import tracker from "../assets/molelos/tracker.webp";
import montana from "../assets/molelos/montana.webp";
import spin from "../assets/molelos/spin.webp";
import onixplus from "../assets/molelos/onixplus.webp";
import captiva from "../assets/molelos/captiva.webp";

export const ConsContext = createContext();

export const useCons = () => {
  const context = useContext(ConsContext);
  if (!context) throw new Error("useCons must be used within a ConsContext");
  return context;
};

export const ConsContextProvider = ({ children }) => {
  const prices = {
    onix12: {
      cuota: "331.358",
      valor: "31.505.900"
    },
    onixplus: {
      cuota: "338.301",
      valor: "31.505.900"
    },
    tracker: {
      cuota: "411.857",
      valor: "39.159.900"
    },
    montana: {
      cuota: "414.939",
      valor: "39.452.900"
    },
    spin: {
      cuota: "435.603",
      valor: "35.116.900"
    },
    s10: {
      cuota: "537.311",
      valor: "48.596.900"
    },
    captiva: {
      cuota: "654.207",
      valor: "52.740.000"
    }
  };

  const modelos = [
    {
      id: 1,
      nombre: "Onix 1.0 TURBO MT",
      modelo: "Onix 1.0 TURBO MT",
      cuota: prices.onix12.cuota,
      plan: "80% en Cuotas",
      text1: `Retirá con el 20% o tu usado`,
      text2: "Hasta en 120 Cuotas",
      text3: `Valor de Lista: $${prices.onix12.valor}`,
      img: onix12,
      cupo: 4,
      dataButton: "Plan Onix 1.0 TURBO MT"
    },
    {
      id: 2,
      nombre: "Onix Plus 1.0 TURBO MT",
      modelo: "Onix Plus 1.0 TURBO MT",
      cuota: prices.onixplus.cuota,
      plan: "80% en Cuotas",
      text1: `Retirá con el 20% o tu usado`,
      text2: "Hasta en 120 Cuotas",
      text3: `Valor de Lista: $${prices.onixplus.valor}`,
      img: onixplus,
      cupo: 4,
      dataButton: "Plan Onix Plus 1.0 TURBO MT"
    },
    {
      id: 3,
      nombre: "CAPTIVA PHEV",
      modelo: "CAPTIVA PHEV",
      cuota: prices.captiva.cuota,
      plan: "70% en Cuotas",
      text1: `Retirá con el 30% o tu usado`,
      text2: "Hasta en 84 Cuotas",
      text3: `Valor de Lista: $${prices.captiva.valor}`,
      img: captiva,
      cupo: 3,
      dataButton: "Plan CAPTIVA PHEV"
    },
    {
      id: 4,
      nombre: "TRACKER 1.2T AT",
      modelo: "TRACKER 1.2T AT",
      cuota: prices.tracker.cuota,
      plan: "80% en Cuotas",
      text1: `Retirá con el 20% o tu usado`,
      text2: "Hasta en 84 Cuotas",
      text3: `Valor de Lista: $${prices.tracker.valor}`,
      img: tracker,
      cupo: 2,
      dataButton: "Plan TRACKER 1.2T AT"
    },
    {
      id: 5,
      nombre: "MONTANA AT 1.2T",
      modelo: "MONTANA AT 1.2T",
      cuota: prices.montana.cuota,
      plan: "70% en Cuotas",
      text1: `Retirá con el 30% o tu usado`,
      text2: "Hasta en 84 Cuotas",
      text3: `Valor de Lista: $${prices.montana.valor}`,
      img: montana,
      cupo: 5,
      dataButton: "Plan MONTANA AT 1.2T"
    },
    {
      id: 6,
      nombre: "SPIN 1.8",
      modelo: "SPIN 1.8",
      cuota: prices.spin.cuota,
      plan: "70% en Cuotas",
      text1: `Retirá con el 30% o tu usado`,
      text2: "Hasta en 84 Meses",
      text3: `Valor de Lista: $${prices.spin.valor}`,
      img: spin,
      cupo: 3,
      dataButton: "Plan SPIN 1.8"
    },
    {
      id: 7,
      nombre: "S10 2.8 TD",
      modelo: "S10 2.8 TD",
      cuota: prices.s10.cuota,
      plan: "60% en Cuotas",
      text1: `Retirá con el 40% o tu usado`,
      text2: "Hasta en 84 Meses",
      text3: `Valor de Lista: $${prices.s10.valor}`,
      img: s10,
      cupo: 4,
      dataButton: "Plan S10 2.8 TD"
    },
  ];

  const themeOptions = {
    acentcolor: "#cd9834",
    dealer: "Roycan",
    carBrand: "Chevrolet",
    brand: "src/img/logo.png",
    logo: "src/img/logoCons.png",
    urlHook: "https://hook.integromat.com/qb1d5iqv47uptf4g013fjk0bothmi4ha"
  };

  const modelsOptions = modelos.map((model) => {
    return {
      value: model.dataButton,
      text: `${model.dataButton} (Cuota $${model.cuota})`,
      disabled: model.disabled
    };
  });

  console.log(modelsOptions);

  return (
    <ConsContext.Provider
      value={{
        prices,
        modelos,
        modelsOptions,
        themeOptions
      }}
    >
      {children}
    </ConsContext.Provider>
  );
};
